import React from 'react';
import './Alert.css';

/**
 * Alert Component
 * Standardized alert message component
 * 
 * @param {string} variant - Alert variant: 'info'|'success'|'warning'|'error' (default: 'info')
 * @param {string} title - Alert title
 * @param {ReactNode} children - Alert content
 * @param {boolean} dismissible - Show dismiss button (default: false)
 * @param {function} onDismiss - Dismiss handler: () => void
 * @param {string} className - Additional CSS classes
 */
const Alert = ({
  variant = 'info',
  title,
  children,
  dismissible = false,
  onDismiss,
  className = ''
}) => {
  const variantClass = `alert-${variant}`;
  
  return (
    <div className={`alert ${variantClass} ${className}`.trim()}>
      <div className="alert-content">
        {title && (
          <div className="alert-title">{title}</div>
        )}
        <div className="alert-message">{children}</div>
      </div>
      {dismissible && (
        <button
          className="alert-dismiss"
          onClick={onDismiss}
          aria-label="Dismiss alert"
        >
          ×
        </button>
      )}
    </div>
  );
};

export default Alert;










